import AppResource from "ss-js-engine/src/Data/AppResource";
import AppResourceCollection from "ss-js-engine/src/Data/AppResourceCollection";
import {flattenKeys} from "ss-js-engine/src/Helpers/Misc/objectHelpers";
import get from "lodash/get";

class WildAppResource extends AppResource {
    /**
     *
     * @param relationName
     * @param relationData
     */
    setRelation(relationName, relationData, relationType) {

        const isRawCollection = relationData &&
            !Array.isArray(relationData) &&
            !(relationData instanceof AppResource) &&
            !(relationData instanceof AppResourceCollection) &&
            !relationData.hasOwnProperty('attributes');

        if (relationName && isRawCollection && relationType === 'WildAppResource') {
            this._relations[relationName] = relationData
            return;
        }

        return super.setRelation(relationName, relationData, relationType);
    }

    /**
     * @returns {*[]}
     */
    relationObjectFlatTreeData(relationMap = [], notIncluded = false) {
        let resources = [], part, path, pathParts,
            relations = flattenKeys(this.relationObjectTree()),
            recordResource = (resource, path) => {
                if(resource instanceof AppResource) {
                    let primaryKey, primaryVal,
                        resourceType = resource.appResourceType();

                    if ((relationMap.includes(path) || relationMap.includes(resourceType)) ? !notIncluded : notIncluded) {
                        primaryVal = get(resource, primaryKey = 'uuid', get(resource, '_uuid'));
                        primaryVal = primaryVal ? primaryVal : get(resource, primaryKey = 'id', get(resource, '_id'));
                    }

                    !primaryVal || resources.push({
                        path: path,
                        type: resourceType,
                        primaryKey: primaryKey,
                        primaryValue: primaryVal,
                    });
                } else if(resource instanceof AppResourceCollection) {
                    resource.forEach(subRelation => recordResource(subRelation, path));
                }
            };

        for(const i in relations) {
            path = '';
            pathParts = relations[i].split('.');
            while(Boolean(part = pathParts.shift())) {
                path += (!path ? '' : '.') + part;
                recordResource(get(this, path), path);
            }
        }

        return resources;
    }

}

export default WildAppResource;
